import { createStore } from 'redux';
import rootReducer from './reducer';

// Clean up corrupted or oversized localStorage
const cleanupLocalStorage = () => {
  try {
    const storedState = localStorage.getItem('sessionState');
    if (storedState && storedState.length > 5 * 1024 * 1024) { // 5MB limit
      console.warn('Found oversized localStorage data, cleaning up...');
      localStorage.removeItem('sessionState');
    }
  } catch (error) {
    console.warn('Error checking localStorage, clearing it:', error);
    localStorage.removeItem('sessionState');
  }
};

// Run cleanup on app start
cleanupLocalStorage();

// Save state to localStorage (excluding large data like photos)
const saveStateToLocalStorage = (state) => {
  try {
    // Create a copy of session state without large data
    const sessionStateToSave = {
      ...state.session,
      setUserPhoto: null, // Exclude photos to prevent quota exceeded error
    };
    
    // Also exclude form data if it contains large images/files
    const formDataToSave = state.form ? {
      ...state.form,
      formData: state.form.formData ? state.form.formData.map(item => {
        // If the item has photo data, exclude it
        if (item && typeof item === 'object') {
          const { photo, photoFile, ...itemWithoutPhoto } = item;
          return itemWithoutPhoto;
        }
        return item;
      }) : []
    } : null;
    
    const stateToSave = {
      session: sessionStateToSave,
      // Don't save form data to localStorage to prevent quota issues
      // form: formDataToSave,
    };
    
    const serializedState = JSON.stringify(stateToSave);
    
    // Check if the data size is reasonable (less than 4MB to be safe)
    if (serializedState.length > 4 * 1024 * 1024) {
      console.warn('Session state too large for localStorage, saving minimal data only');
      const minimalState = {
        session: {
          sessionId: state.session.sessionId,
          setUserId: state.session.setUserId,
          setUserName: state.session.setUserName,
          isAdmin: state.session.isAdmin || false,
          setUser: null,
          setUserPhoto: null,
        }
      };
      localStorage.setItem('sessionState', JSON.stringify(minimalState));
    } else {
      localStorage.setItem('sessionState', serializedState);
    }
  } catch (error) {
    console.error('Error saving state to localStorage:', error);
    // Try to save minimal essential data only
    try {
      const essentialState = {
        session: {
          sessionId: state.session.sessionId,
          setUserId: state.session.setUserId,
          setUserName: state.session.setUserName,
          isAdmin: state.session.isAdmin || false,
          setUser: null,
          setUserPhoto: null,
        }
      };
      localStorage.setItem('sessionState', JSON.stringify(essentialState));
    } catch (fallbackError) {
      console.error('Failed to save even minimal state:', fallbackError);
      // Clear the localStorage to prevent corruption
      localStorage.removeItem('sessionState');
    }
  }
};

const store = createStore(rootReducer);

// Subscribe to store changes and save session state to localStorage
store.subscribe(() => {
  saveStateToLocalStorage(store.getState());
});

export default store;
